import { render, staticRenderFns } from "./pageloader.vue?vue&type=template&id=b815a758&scoped=true&"
import script from "./pageloader.vue?vue&type=script&lang=js&"
export * from "./pageloader.vue?vue&type=script&lang=js&"
import style0 from "./pageloader.vue?vue&type=style&index=0&id=b815a758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815a758",
  null
  
)

export default component.exports